@if ((useLazyLoad && !isLoaded) || teasers?.length > 0) {
  <sd-teaser #teaserCmp
    [sdSpyTarget]="componentUid"
    [isLarge]="isLarge"
    [data]="teasers"
    [autoplay]="autoplay"
    [loop]="loop"
    [titleLevel]="titleLevel"
    [context]="context"
    [twicPicsAutoSize]="false"
    [brand]="brandCorner"
    [hasAlphaHeader]="hasAlphaHeader"
    [isLoading]="useLazyLoad && !isLoaded"
    (clicked)="onClicked($event)"
  />
}
